module.exports = __webpack_public_path__ + "static/media/Lato-ThinItalic.4ac7208b.ttf";